import { Collapse, Fab, Stack } from "@mui/material";
import CommentIcon from "@mui/icons-material/Comment";
import { useState } from "react";

export default function FeedbackButton(params: { onClick?: () => void }) {
  const [showDescription, setShowDescription] = useState(false);

  return (
    <Fab
      variant={showDescription ? "extended" : "circular"}
      size="large"
      color="primary"
      sx={{
        position: "fixed",
        bottom: 32,
        right: 32,
      }}
      onMouseEnter={() => setShowDescription(true)}
      onMouseLeave={() => setShowDescription(false)}
      onClick={params.onClick}
    >
      <CommentIcon sx={showDescription ? { mr: 1 } : {}} />
      <Collapse
        orientation="horizontal"
        in={showDescription}
        sx={{ textWrap: "nowrap" }}
      >
        Lämna feedback
      </Collapse>
    </Fab>
  );
}
